function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React, { useEffect, useCallback, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useDataApi } from '@adsk/alloy-helpers';
import { track } from '@adsk/acs-web-analytics';
import { useCurrentAccountId, useUser, useAlloyFeatureFlag } from '@adsk/alloy-provider';
import { useLocale } from '@adsk/alloy-react-locale';
import { withAdminFFs, useAdminFeatureFlag, withPlangridFFs, usePlangridFeatureFlag } from '@adsk/acs-admin-ui-components-shared-components';
import { ACCESS_LEVELS, COMPONENT_VARIANTS, OP_STATUSES, TIME_ZONES, TRACK_EVENTS, FLAG_NAMES } from '@adsk/acs-admin-ui-components-helpers';
import { useGetProjectTypes, useGetAccountOfferings } from '@adsk/acs-admin-ui-components-hooks';
import { useFormik } from 'formik';
import CreateProjectModalView from './component';
import { buildAccountsRequest, buildAddUserToProjectRequest, buildCreateProjectRequest, buildGetProjectRolesRequest, buildGetProjectUserRequest, buildTemplatesRequest, dataEntered, getAdminUserAccess, getProjectAdminConsoleTeamPageUrl, getProjectData, isDuplicateNameError, validateDate, validProjectValue } from './utils';
import { useGlobalTemplates, usePublishedTemplates } from './hooks';
import { initialState } from './constants';
export function CreateProjectModal(_ref) {
  var _userData$user, _values$selectedAccou, _values$selectedAccou2;
  var accountId = _ref.accountId,
    isEmsAccount = _ref.isEmsAccount,
    mapBoxAccessToken = _ref.mapBoxAccessToken,
    onClose = _ref.onClose,
    onSubmit = _ref.onSubmit,
    show = _ref.show,
    templateId = _ref.templateId,
    uiDomainUrl = _ref.uiDomainUrl,
    variant = _ref.variant,
    includeGlobalTemplates = _ref.includeGlobalTemplates;
  var _useFormik = useFormik({
      initialValues: initialState,
      validateOnBlur: false,
      validateOnChange: false
    }),
    errors = _useFormik.errors,
    handleBlur = _useFormik.handleBlur,
    handleChange = _useFormik.handleChange,
    setFieldError = _useFormik.setFieldError,
    setFieldValue = _useFormik.setFieldValue,
    setValues = _useFormik.setValues,
    values = _useFormik.values;
  var _useLocale = useLocale(function (_ref2) {
      var locale = _ref2.locale;
      return require("./i18n/".concat(locale, ".json"));
    }),
    T = _useLocale.T;
  var currentAccountId = useCurrentAccountId();
  var userData = useUser();
  var currentUserEmail = userData === null || userData === void 0 ? void 0 : (_userData$user = userData.user) === null || _userData$user === void 0 ? void 0 : _userData$user.email;
  var _FLAG_NAMES$ADMIN_FLA = FLAG_NAMES.ADMIN_FLAGS,
    ACC_REPLACE_WRITE_CONSTRUCTION_APIS = _FLAG_NAMES$ADMIN_FLA.ACC_REPLACE_WRITE_CONSTRUCTION_APIS,
    ENABLE_PRODUCT_ACCESS_IN_PROJECT_CREATION = _FLAG_NAMES$ADMIN_FLA.ENABLE_PRODUCT_ACCESS_IN_PROJECT_CREATION,
    _FLAG_NAMES$WPLT_FLAG = FLAG_NAMES.WPLT_FLAGS,
    ACC_PROJECT_PROFILE_ADDITIONAL_FIELDS = _FLAG_NAMES$WPLT_FLAG.ACC_PROJECT_PROFILE_ADDITIONAL_FIELDS,
    CREATE_PROJECT_REDIRECT_PA_CONSOLE = _FLAG_NAMES$WPLT_FLAG.CREATE_PROJECT_REDIRECT_PA_CONSOLE,
    PL_PROJECT_TEMPLATES_MAINTENANCE_MODE = _FLAG_NAMES$WPLT_FLAG.PL_PROJECT_TEMPLATES_MAINTENANCE_MODE;

  // Load Admin Feature Flags
  var _useAdminFeatureFlag = useAdminFeatureFlag(ACC_REPLACE_WRITE_CONSTRUCTION_APIS),
    loadingUseWriteConstructionApis = _useAdminFeatureFlag.loading,
    useWriteConstructionApis = _useAdminFeatureFlag.value;
  var _useAdminFeatureFlag2 = useAdminFeatureFlag(ENABLE_PRODUCT_ACCESS_IN_PROJECT_CREATION),
    loadingTurnOnPurchasedProductsFF = _useAdminFeatureFlag2.loading,
    useTurnOnPurchasedProductsFF = _useAdminFeatureFlag2.value;

  // Load Web Platform Feature Flags
  var _useAlloyFeatureFlag = useAlloyFeatureFlag(ACC_PROJECT_PROFILE_ADDITIONAL_FIELDS),
    loadingAdditionalFieldsActivated = _useAlloyFeatureFlag.loading,
    additionalFieldsActivated = _useAlloyFeatureFlag.value;
  var _useAlloyFeatureFlag2 = useAlloyFeatureFlag(CREATE_PROJECT_REDIRECT_PA_CONSOLE),
    loadingPaConsoleRedirectActivated = _useAlloyFeatureFlag2.loading,
    paConsoleRedirectActivated = _useAlloyFeatureFlag2.value;
  var _usePlangridFeatureFl = usePlangridFeatureFlag(PL_PROJECT_TEMPLATES_MAINTENANCE_MODE),
    loadingTemplatesMaintenanceModeEnabled = _usePlangridFeatureFl.loading,
    templatesMaintenanceModeEnabled = _usePlangridFeatureFl.value;
  var areFFsLoading = loadingAdditionalFieldsActivated || loadingPaConsoleRedirectActivated || loadingUseWriteConstructionApis || loadingTurnOnPurchasedProductsFF || loadingTemplatesMaintenanceModeEnabled;
  var getAccountsRequest = useMemo(function () {
    return buildAccountsRequest();
  }, []);
  // Fetch Accounts
  var _useDataApi = useDataApi(getAccountsRequest),
    accountsData = _useDataApi.data,
    isFetchingAccounts = _useDataApi.loading;
  var _useDataApi2 = useDataApi(),
    templatesData = _useDataApi2.data,
    isFetchingTemplates = _useDataApi2.loading,
    doFetchTemplates = _useDataApi2.doFetch;
  // Create Project
  var _useDataApi3 = useDataApi(),
    createProjectData = _useDataApi3.data,
    createProjectError = _useDataApi3.error,
    doCreateProjectFetch = _useDataApi3.doFetch;
  // Assign current user as Project Admin
  var _useDataApi4 = useDataApi(),
    addUserData = _useDataApi4.data,
    addUserError = _useDataApi4.error,
    doAddUserFetch = _useDataApi4.doFetch;
  var _useDataApi5 = useDataApi(),
    projectUserRequestData = _useDataApi5.data,
    projectUserRequestError = _useDataApi5.error,
    doProjectUserFetch = _useDataApi5.doFetch;
  var _useDataApi6 = useDataApi(),
    projectRolesData = _useDataApi6.data,
    doProjectRolesFetch = _useDataApi6.doFetch;
  var _usePublishedTemplate = usePublishedTemplates(values.selectedAccount),
    loadingPublishedTemplates = _usePublishedTemplate.loading,
    publishedTemplates = _usePublishedTemplate.templates;
  var _useGlobalTemplates = useGlobalTemplates(),
    loadingGlobalTemplates = _useGlobalTemplates.loading,
    globalTemplates = _useGlobalTemplates.templates;
  var filterAccountsByAccessLevels = function filterAccountsByAccessLevels(accounts) {
    return accounts.filter(function (account) {
      var _account$createProjec, _account$createProjec2, _account$createProjec3;
      var isProjectAdmin = account.accessLevels.projectAdmin;
      var isAccountAdmin = account.accessLevels.accountAdmin;
      var isAccountStandardsAdmin = account.accessLevels.accountStandardsAdministrator;
      var hasAccountAdminAccessLevel = (_account$createProjec = account.createProjectAccessLevels) === null || _account$createProjec === void 0 ? void 0 : _account$createProjec.includes(ACCESS_LEVELS.ACCOUNT_ADMIN);
      var hasAccountStandardsAdminAccessLevel = (_account$createProjec2 = account.createProjectAccessLevels) === null || _account$createProjec2 === void 0 ? void 0 : _account$createProjec2.includes(ACCESS_LEVELS.ACCOUNT_STANDARDS_ADMINISTRATOR);
      var hasProjectAdminAccessLevel = (_account$createProjec3 = account.createProjectAccessLevels) === null || _account$createProjec3 === void 0 ? void 0 : _account$createProjec3.includes(ACCESS_LEVELS.PROJECT_ADMIN);
      return isAccountAdmin && hasAccountAdminAccessLevel || isAccountStandardsAdmin && hasAccountStandardsAdminAccessLevel || isProjectAdmin && hasProjectAdminAccessLevel;
    });
  };
  var accounts = useMemo(function () {
    if (!accountsData) {
      return [];
    }
    var filteredAccountsData = accountsData.results.filter(function (account) {
      return account.accessLevels.accountAdmin && (account.hasAcsUnifiedProjects || account.isAccEligible) || account.accessLevels.accountStandardsAdministrator && (account.hasAcsUnifiedProjects || account.isAccEligible) || variant === COMPONENT_VARIANTS.PROJECT && (account.accessLevels.acsProjectAdmin || account.accessLevels.projectAdmin && account.isAccEligible);
    });
    return filterAccountsByAccessLevels(filteredAccountsData);
  }, [accountsData, variant]);
  var templates = useMemo(function () {
    // Although unlikely, there could be a published template that also has the user as a member.
    // In that case we want to show it as an account published template.
    var publishedTemplatesIds = publishedTemplates.map(function (_ref3) {
      var id = _ref3.id;
      return id;
    });
    var publishedTemplatesFound = !loadingPublishedTemplates && templatesData ? publishedTemplates.concat(templatesData.results.filter(function (_ref4) {
      var id = _ref4.id;
      return !publishedTemplatesIds.includes(id);
    })) : [];
    var globalTemplatesFound = !loadingGlobalTemplates ? globalTemplates : [];
    if (!loadingGlobalTemplates && globalTemplates && !values.globalTemplateIds) {
      setFieldValue('globalTemplateIds', globalTemplates.map(function (_ref5) {
        var id = _ref5.id;
        return id;
      }));
    }
    if (includeGlobalTemplates) return [].concat(_toConsumableArray(publishedTemplatesFound), _toConsumableArray(globalTemplatesFound));
    return publishedTemplatesFound;
  }, [publishedTemplates, loadingPublishedTemplates, templatesData, loadingGlobalTemplates, globalTemplates, setFieldValue, includeGlobalTemplates]);
  var _useGetProjectTypes = useGetProjectTypes((_values$selectedAccou = values.selectedAccount) === null || _values$selectedAccou === void 0 ? void 0 : _values$selectedAccou.id),
    projectTypes = _useGetProjectTypes.projectTypes,
    isFetchingProjectTypes = _useGetProjectTypes.isFetchingProjectTypes;
  var _useGetAccountOfferin = useGetAccountOfferings(true, (_values$selectedAccou2 = values.selectedAccount) === null || _values$selectedAccou2 === void 0 ? void 0 : _values$selectedAccou2.id),
    accountOfferingProducts = _useGetAccountOfferin.offeringProducts,
    isLoadingOfferingProducts = _useGetAccountOfferin.isLoadingOfferingProducts;
  var latestOnSubmit = useRef(onSubmit);
  var sendAnalytics = function sendAnalytics(type) {
    track("".concat(TRACK_EVENTS.SCOPE.PROJECT_ADMIN, ".").concat(TRACK_EVENTS.SOURCE.CREATE_PROJECT, ".").concat(type), {
      template_selected: !!values.selectedTemplate,
      product_id: variant === COMPONENT_VARIANTS.ACCOUNT ? 'account_admin' : 'project_list',
      address: values.autocompletedAddress !== '' || Object.values(values.address).some(function (e) {
        return e !== '';
      })
    });
  };
  var sendGlobalTemplatesAnalytics = useCallback(function (event) {
    var templateData = globalTemplates.filter(function (_ref6) {
      var id = _ref6.id;
      return id === templateId;
    });
    track("project_template.sample_templates.create_project_dialog.".concat(event), {
      sampleTemplate: templateData.length ? templateData[0].name : ''
    });
  }, [globalTemplates, templateId]);
  var resetInputState = useCallback(function () {
    setValues(_objectSpread(_objectSpread({}, initialState), {}, {
      isMapboxTokenActive: values.isMapboxTokenActive,
      addressInputMode: values.addressInputMode
    }));
  }, [setValues, values.addressInputMode, values.isMapboxTokenActive]);
  var handleProjectCreated = function handleProjectCreated() {
    latestOnSubmit.current({
      status: OP_STATUSES.SUCCESS,
      response: createProjectData,
      metadata: {
        templateId: values.selectedTemplate
      }
    });
    resetInputState();
    setFieldValue('isSaving', false);
  };

  // Handle Create project
  var handleSubmitCreateProject = function handleSubmitCreateProject() {
    setFieldValue('isSaving', true);
    var projectData = getProjectData(values, additionalFieldsActivated, useWriteConstructionApis);
    doCreateProjectFetch.apply(void 0, _toConsumableArray(buildCreateProjectRequest({
      accountId: values.selectedAccount.id,
      projectData: projectData,
      useConstructionApi: useWriteConstructionApis
    })));
    if (includeGlobalTemplates) sendGlobalTemplatesAnalytics('submit');
  };
  var setMapboxTokenActive = useCallback(function (active) {
    return setFieldValue('isMapboxTokenActive', active);
  }, [setFieldValue]);
  var handleAccountChange = function handleAccountChange(option) {
    setFieldValue('selectedTemplate', null);
    setFieldValue('selectedProjectType', null);
    if (errors.projectName) {
      setFieldError('projectName', null);
    }
    setFieldValue('selectedAccount', option);
  };
  var handleAddressInputModeChange = useCallback(function (inputMode) {
    var resetAddress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    setFieldValue('addressInputMode', inputMode);
    if (resetAddress) {
      setFieldValue('autocompletedAddress', '');
      setFieldValue('address', initialState.address);
    }
  }, [setFieldValue]);
  var handleAutocompletedAddressChange = function handleAutocompletedAddressChange(autocompletedAddress) {
    setFieldValue('autocompletedAddress', autocompletedAddress);
  };
  var handleAddressChange = function handleAddressChange(address) {
    var newAddress = _objectSpread(_objectSpread({}, values.address), address);
    setFieldValue('address', newAddress);
  };
  var handleStartDateChange = useCallback(function (event) {
    setFieldValue('startDate', validateDate(event));
  }, [setFieldValue]);
  var handleEndDateChange = useCallback(function (event) {
    setFieldValue('endDate', validateDate(event));
  }, [setFieldValue]);
  var handleCancelClick = useCallback(function () {
    var isCancelButton = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    try {
      if (dataEntered(initialState, values, accounts.length, additionalFieldsActivated, variant, accountId, templateId)) {
        setFieldValue('showModalConfirmation', true);
      } else {
        resetInputState();
        onClose();
      }
      if (includeGlobalTemplates && isCancelButton) sendGlobalTemplatesAnalytics('cancel');
    } catch (error) {
      console.warn('Error in handleCancelClick of CreateProjectModal', error);
      setFieldValue('showModalConfirmation', true);
    }
  }, [accountId, accounts.length, additionalFieldsActivated, includeGlobalTemplates, onClose, resetInputState, sendGlobalTemplatesAnalytics, setFieldValue, templateId, values, variant]);
  var handleModalCloseClick = function handleModalCloseClick() {
    handleCancelClick(false);
    if (includeGlobalTemplates) sendGlobalTemplatesAnalytics('close');
  };
  var handleModalConfirmationConfirm = function handleModalConfirmationConfirm() {
    sendAnalytics(TRACK_EVENTS.NAME.CANCEL);
    setFieldValue('showModalConfirmation', false);
    resetInputState();
    onClose();
  };
  var handleModalConfirmationCancel = function handleModalConfirmationCancel() {
    setFieldValue('showModalConfirmation', false);
  };
  var handleProjectValueChange = useCallback(function (event) {
    if (validProjectValue(event.target.value)) {
      setFieldValue('projectValue', event.target.value);
      setFieldError('projectValue', null);
    } else {
      setFieldError('projectValue', T.translate('PROJECT_VALUE_ERROR'));
    }
  }, [setFieldError, setFieldValue, T]);
  var handleProjectTypeChange = function handleProjectTypeChange(option) {
    return setFieldValue('selectedProjectType', option);
  };
  var handleTemplateChange = function handleTemplateChange(option) {
    return setFieldValue('selectedTemplate', option);
  };
  var handleTimeZoneChange = function handleTimeZoneChange(option) {
    return setFieldValue('selectedTimeZone', option);
  };
  var handleCurrencyChange = function handleCurrencyChange(option) {
    return setFieldValue('selectedCurrency', option);
  };
  useEffect(function () {
    latestOnSubmit.current = onSubmit;
  }, [onSubmit]);
  useEffect(function () {
    setFieldError('projectName', null);
  }, [values.projectName, setFieldError]);

  // Set default value for the account select box
  useEffect(function () {
    if (!accountsData || !(currentAccountId || accountId) || values.selectedAccount) return;
    if (accountId) {
      var preselectedAccount = accountsData.results.find(function (account) {
        return account.id === accountId;
      });
      setFieldValue('selectedAccount', preselectedAccount);
    } else if (variant === COMPONENT_VARIANTS.ACCOUNT) {
      var defaultAccount = accountsData.results.find(function (account) {
        return account.id === currentAccountId;
      });
      setFieldValue('selectedAccount', defaultAccount);
    } else if (accountsData.results.length === 1) {
      // When the user only has access to one organization
      setFieldValue('selectedAccount', accountsData.results[0]);
    }
  }, [accountId, accountsData, currentAccountId, setFieldValue, values.selectedAccount, variant]);

  // Set default value for the template select box
  useEffect(function () {
    if (!templatesData) return;
    if (templateId) {
      var additionalTemplates = includeGlobalTemplates ? globalTemplates : [];
      var preselectedTemplate = [].concat(_toConsumableArray(templatesData.results), _toConsumableArray(additionalTemplates)).find(function (template) {
        return template.id === templateId;
      });
      setFieldValue('selectedTemplate', preselectedTemplate);
    }
  }, [globalTemplates, includeGlobalTemplates, setFieldValue, templateId, templatesData]);

  // When selected account changes, fetch project types, templates and services
  useEffect(function () {
    if (templatesMaintenanceModeEnabled || !values.selectedAccount) return;
    var accountId = values.selectedAccount.id;
    doFetchTemplates(buildTemplatesRequest(accountId, useWriteConstructionApis));
  }, [doFetchTemplates, templatesMaintenanceModeEnabled, values.selectedAccount, useWriteConstructionApis]);

  // Validate required fields
  useEffect(function () {
    var emptyField = !values.selectedProjectType && !isEmsAccount || !values.selectedAccount || !values.projectName;
    if (emptyField !== values.missingRequiredField) {
      setFieldValue('missingRequiredField', emptyField);
    }
  }, [isEmsAccount, setFieldValue, values.missingRequiredField, values.projectName, values.selectedAccount, values.selectedProjectType]);

  // Set the project's time zone to the user's time zone
  useEffect(function () {
    if (show && additionalFieldsActivated && !isEmsAccount) {
      var currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (currentTimeZone && TIME_ZONES.includes(currentTimeZone)) {
        setFieldValue('selectedTimeZone', {
          value: currentTimeZone
        });
      }
    }
  }, [show, additionalFieldsActivated, isEmsAccount, setFieldValue]);

  // Assign user success
  useEffect(function () {
    if (!addUserData || !createProjectData) return;
    sendAnalytics(TRACK_EVENTS.NAME.COMPLETE);
    if (paConsoleRedirectActivated) {
      if (!isEmsAccount) {
        doProjectRolesFetch(buildGetProjectRolesRequest(createProjectData.id));
      } else {
        doProjectUserFetch(buildGetProjectUserRequest(createProjectData.id, addUserData.id, useWriteConstructionApis));
      }
    } else {
      handleProjectCreated();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addUserData]);

  // Assign user error
  useEffect(function () {
    if (!addUserError) return;
    setFieldValue('isSaving', false);
    latestOnSubmit.current({
      status: OP_STATUSES.ERROR,
      response: addUserError
    });
  }, [addUserError, setFieldValue]);

  // Create Project Success
  useEffect(function () {
    if (!createProjectData) return;
    var projectId = createProjectData.id,
      services = createProjectData.services;
    var projectUserData = _defineProperty({
      email: currentUserEmail
    }, useWriteConstructionApis ? 'products' : 'services', getAdminUserAccess(useWriteConstructionApis, services, accountOfferingProducts, useTurnOnPurchasedProductsFF));
    doAddUserFetch.apply(void 0, _toConsumableArray(buildAddUserToProjectRequest({
      projectId: projectId,
      userData: projectUserData,
      useConstructionApi: useWriteConstructionApis
    })));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createProjectData]);

  // Create Project Error
  useEffect(function () {
    if (!createProjectError) return;
    setFieldValue('isSaving', false);
    // Intercept and display the duplicate name field error
    if (createProjectError.errors && isDuplicateNameError(createProjectError.errors)) {
      setFieldError('projectName', T.translate('NAME_DUPLICATE_ERROR'));
    } else {
      // return other errors
      latestOnSubmit.current({
        status: OP_STATUSES.ERROR,
        response: createProjectError
      });
    }
  }, [createProjectError, setFieldError, setFieldValue, T]);
  useEffect(function () {
    if (!projectUserRequestData) return;
    handleProjectCreated();
    window.location.assign(getProjectAdminConsoleTeamPageUrl({
      isEmsAccount: isEmsAccount,
      projectId: createProjectData.id,
      uiDomainUrl: uiDomainUrl
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectUserRequestData]);
  useEffect(function () {
    if (!projectUserRequestError) return;
    setTimeout(function () {
      doProjectUserFetch(buildGetProjectUserRequest(createProjectData.id, addUserData.id, useWriteConstructionApis));
    }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectUserRequestError]);
  useEffect(function () {
    if (!projectRolesData) return;
    if (projectRolesData.results.length > 0) {
      doProjectUserFetch(buildGetProjectUserRequest(createProjectData.id, addUserData.id, useWriteConstructionApis));
    } else {
      setTimeout(function () {
        doProjectRolesFetch(buildGetProjectRolesRequest(createProjectData.id));
      }, 2000);
    }
  }, [projectRolesData]);
  useEffect(function () {
    if (values.selectedCurrency && isEmsAccount) {
      setFieldValue('selectedCurrency', null);
    }
  }, [isEmsAccount, setFieldValue, values.selectedCurrency]);
  if (areFFsLoading) {
    return null;
  }
  return /*#__PURE__*/React.createElement(CreateProjectModalView, {
    accountId: accountId,
    accounts: accounts,
    isEmsAccount: isEmsAccount,
    additionalFieldsActivated: additionalFieldsActivated,
    errors: errors,
    isFetchingAccounts: isFetchingAccounts,
    isFetchingAccountOfferings: isLoadingOfferingProducts,
    isFetchingProjectTypes: isFetchingProjectTypes,
    isFetchingTemplates: isFetchingTemplates || loadingPublishedTemplates,
    isTemplatesMaintenanceMode: templatesMaintenanceModeEnabled,
    mapBoxAccessToken: mapBoxAccessToken,
    onBlur: handleBlur,
    onChange: handleChange,
    onChangeAccount: handleAccountChange,
    onChangeAddress: handleAddressChange,
    onChangeAddressInputMode: handleAddressInputModeChange,
    onChangeAutocompletedAddress: handleAutocompletedAddressChange,
    onChangeCurrency: handleCurrencyChange,
    onChangeEndDate: handleEndDateChange,
    onChangeProjectType: handleProjectTypeChange,
    onChangeProjectValue: handleProjectValueChange,
    onChangeStartDate: handleStartDateChange,
    onChangeTemplate: handleTemplateChange,
    onChangeTimeZone: handleTimeZoneChange,
    onClickCancel: handleCancelClick,
    onCloseModal: handleModalCloseClick,
    onModalConfirmationCancel: handleModalConfirmationCancel,
    onModalConfirmationConfirm: handleModalConfirmationConfirm,
    onSubmitCreateProject: handleSubmitCreateProject,
    projectTypes: projectTypes,
    setMapboxTokenActive: setMapboxTokenActive,
    show: show,
    templateId: templateId,
    templates: templates,
    values: values
  });
}
CreateProjectModal.propTypes = {
  /** Account id to pre-populate (optional) */
  accountId: PropTypes.string,
  /** Boolean property to set the visibility of the Global Templates in the templatesField */
  includeGlobalTemplates: PropTypes.bool,
  /** Account type to pre-populate (optional - default construction) */
  isEmsAccount: PropTypes.bool,
  /**
   * Required Access token for the Mapbox address component.
   * If not specified, defaults to manual input flow
   */
  mapBoxAccessToken: PropTypes.string.isRequired,
  /**  handler executed when the user clicks on the Cancel button or on the Close Dialog cross */
  onClose: PropTypes.func.isRequired,
  /** handler executed when the cuser clicks on the Create Project button */
  onSubmit: PropTypes.func.isRequired,
  /** Boolean property to set the visibility of the Modal */
  show: PropTypes.bool,
  /** Template id to pre-populate (optional) */
  templateId: PropTypes.string,
  /** uiDomainUrl: url of current domain, used for CPA projects  */
  uiDomainUrl: PropTypes.string,
  /** Indicates project level or account level create project */
  variant: PropTypes.oneOf(Object.values(COMPONENT_VARIANTS))
};
CreateProjectModal.defaultProps = {
  accountId: undefined,
  includeGlobalTemplates: false,
  isEmsAccount: false,
  show: false,
  templateId: undefined,
  uiDomainUrl: undefined,
  variant: COMPONENT_VARIANTS.PROJECT
};
var CreateProjectModalWithAdminFFs = withAdminFFs(withPlangridFFs(CreateProjectModal));
CreateProjectModalWithAdminFFs.opStatuses = OP_STATUSES;
export default CreateProjectModalWithAdminFFs;
//# sourceMappingURL=container.js.map